import React from 'react';

const AnalysisFlowchart = () => {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <div className="flex flex-col items-center space-y-6">
        {/* Step 1 */}
        <div className="w-full max-w-md">
          <div className="bg-blue-600 text-white p-6 rounded-lg shadow-lg text-center">
            <div className="text-4xl mb-2">🔗</div>
            <h3 className="font-bold text-lg mb-2">Step 1: Submit URL</h3>
            <p className="text-sm">User pastes YouTube video URL</p>
          </div>
        </div>

        {/* Arrow */}
        <div className="text-blue-600 text-4xl">↓</div>

        {/* Step 2 - Parallel Processing */}
        <div className="w-full">
          <div className="bg-purple-100 border-2 border-purple-600 p-6 rounded-lg">
            <h3 className="font-bold text-lg text-center mb-6 text-purple-900">
              Step 2: Multimodal AI Analysis
            </h3>

            <div className="grid md:grid-cols-3 gap-4">
              {/* Visual Analysis */}
              <div className="bg-white p-4 rounded-lg shadow">
                <div className="text-3xl mb-2 text-center">👁️</div>
                <h4 className="font-semibold text-center mb-2">Visual Analysis</h4>
                <ul className="text-sm space-y-1 text-gray-700">
                  <li>• Extract 8-10 keyframes</li>
                  <li>• GPT-4 Vision</li>
                  <li>• Detect hacking tools</li>
                  <li>• Identify terminals</li>
                  <li>• Spot exploits</li>
                </ul>
              </div>

              {/* Audio Analysis */}
              <div className="bg-white p-4 rounded-lg shadow">
                <div className="text-3xl mb-2 text-center">🎤</div>
                <h4 className="font-semibold text-center mb-2">Audio Analysis</h4>
                <ul className="text-sm space-y-1 text-gray-700">
                  <li>• Whisper AI transcription</li>
                  <li>• Keyword detection</li>
                  <li>• Threat language ID</li>
                  <li>• Instructional patterns</li>
                  <li>• Tool references</li>
                </ul>
              </div>

              {/* Metadata Analysis */}
              <div className="bg-white p-4 rounded-lg shadow">
                <div className="text-3xl mb-2 text-center">📊</div>
                <h4 className="font-semibold text-center mb-2">Metadata Analysis</h4>
                <ul className="text-sm space-y-1 text-gray-700">
                  <li>• Title analysis</li>
                  <li>• Description scan</li>
                  <li>• Tag matching</li>
                  <li>• Channel history</li>
                  <li>• Engagement patterns</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="text-blue-600 text-4xl">↓</div>

        {/* Step 3 */}
        <div className="w-full max-w-md">
          <div className="bg-orange-500 text-white p-6 rounded-lg shadow-lg text-center">
            <div className="text-4xl mb-2">🎯</div>
            <h3 className="font-bold text-lg mb-2">Step 3: Risk Scoring</h3>
            <p className="text-sm">Algorithm combines all signals</p>
            <div className="mt-4 bg-white text-orange-500 rounded p-2 font-bold">
              Risk Score: 0-100
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="text-blue-600 text-4xl">↓</div>

        {/* Step 4 */}
        <div className="w-full max-w-md">
          <div className="bg-green-600 text-white p-6 rounded-lg shadow-lg text-center">
            <div className="text-4xl mb-2">📄</div>
            <h3 className="font-bold text-lg mb-2">Step 4: Comprehensive Report</h3>
            <ul className="text-sm text-left mt-4 space-y-1">
              <li>✓ Overall risk assessment</li>
              <li>✓ Frame-by-frame analysis</li>
              <li>✓ Full transcript analysis</li>
              <li>✓ Threat keyword matches</li>
              <li>✓ Downloadable PDF</li>
            </ul>
          </div>
        </div>

        {/* Timing */}
        <div className="mt-4 text-center text-gray-600">
          <p className="text-sm">⏱️ Total Processing Time: 30-60 seconds</p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisFlowchart;
